var React = require('react');

function LayerGroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.776 9.251c-1.034-.469-1.034-2.033 0-2.502L15.335.145C15.51.065 15.808 0 16 0s.49.065.665.145L31.223 6.75c1.034.469 1.034 2.032 0 2.502l-14.559 6.604a1.602 1.602 0 0 1-1.331 0zm30.448 5.518c1.034.469 1.034 2.031 0 2.5l-14.559 6.599a1.61 1.61 0 0 1-1.331 0L.775 17.269c-1.034-.469-1.034-2.031 0-2.5l3.631-1.646 10.102 4.579a3.592 3.592 0 0 0 2.982 0l10.102-4.579zm0 7.987c1.034.469 1.034 2.031 0 2.5l-14.559 6.599a1.61 1.61 0 0 1-1.331 0L.775 25.256c-1.034-.469-1.034-2.031 0-2.5l3.617-1.639 10.116 4.586a3.592 3.592 0 0 0 2.982 0l10.116-4.586z"}));
}

LayerGroup.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = LayerGroup;

LayerGroup.default = LayerGroup;
